<div class="card shadow-sm border-0">
  <div class="card-body">
    <h5 class="mb-3">Step 3 · Validation</h5>

    <div *ngIf="!validationResult" class="text-muted">
      Run validation to see blocking issues and warnings before submission.
    </div>

    <div *ngIf="validationResult">
      <div class="row g-3 mb-3">
        <div class="col-md-4">
          <div class="border rounded p-3">
            <div class="small text-muted">Valid</div>
            <div class="fw-bold" [ngClass]="validationResult.isValid ? 'text-success' : 'text-danger'">
              {{ validationResult.isValid ? 'Yes' : 'No' }}
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="border rounded p-3">
            <div class="small text-muted">Errors</div>
            <div class="fw-bold text-danger">{{ validationResult.errorCount }}</div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="border rounded p-3">
            <div class="small text-muted">Warnings</div>
            <div class="fw-bold text-warning">{{ validationResult.warningCount }}</div>
          </div>
        </div>
      </div>

      <div *ngIf="validationResult.issues?.length; else goodToGo" class="list-group">
        <div class="list-group-item" *ngFor="let issue of validationResult.issues">
          <div class="fw-semibold">{{ issue.message }}</div>
          <div class="small text-muted">
            {{ issue.code }}
            <span *ngIf="issue.fieldKey"> · {{ issue.fieldKey }}</span>
            <span *ngIf="issue.documentTypeCode"> · {{ issue.documentTypeCode }}</span>
          </div>
        </div>
      </div>

      <ng-template #goodToGo>
        <div class="alert alert-success mb-0">
          No blocking issues found.
        </div>
      </ng-template>
    </div>
  </div>
</div>